import { IEmployee } from 'app/shared/model/employee.model';

export interface IOrganization {
  id?: string;
  name?: string;
  companyId?: string | null;
  employees?: IEmployee[] | null;
  isDeleted?: boolean;
  isSameOrganization?: boolean;
}

export const defaultValue: Readonly<IOrganization> = {
  isDeleted: false,
  isSameOrganization: false,
};
